// Author thq
// Date 2021-11-21 13:07:18

class EmSppWarehousingDetSwd {
constructor({
        id = null,
        swdIdSpw = '',
        swdNameSpa = '',
        swdIdSpa = '',
        sprdSpaIdentCode = '',
        swdStatus = '',
        swdPrice = '',
        swdNum = '',
        swdUnit = '',
        swdCodeSat = '',
        swdCodeSso = '',
        swdCodeEloc = '',
        remark = ''}
= {}) {
    this.id = id;
    this.swdIdSpw = swdIdSpw;
    this.swdNameSpa = swdNameSpa;
    this.swdIdSpa = swdIdSpa;
    this.sprdSpaIdentCode = sprdSpaIdentCode;
    this.swdStatus = swdStatus;
    this.swdPrice = swdPrice;
    this.swdNum = swdNum;
    this.swdUnit = swdUnit;
    this.swdCodeSat = swdCodeSat;
    this.swdCodeSso = swdCodeSso;
    this.swdCodeEloc = swdCodeEloc;
    this.remark = remark;
}
}

function newEntity() {
return new EmSppWarehousingDetSwd();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'swdIdSpw',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.grid.swdIdSpw',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'swdNameSpa',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.grid.swdNameSpa',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'swdCodeSpa',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.grid.swdCodeSpa',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sprdSpaIdentCode',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.grid.sprdSpaIdentCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'swdStatus',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.grid.swdStatus',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '0', text: '未入库' },
                            { value: '1', text: '已入库' }
            ]
        }
        },
        {
        key: 'swdPrice',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.grid.swdPrice',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'swdNum',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.grid.swdNum',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'swdUnit',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.grid.swdUnit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'swdCodeSat',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.grid.swdCodeSat',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'swdNameSat',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.grid.swdNameSat',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'swdCodeSso',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.grid.swdCodeSso',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'swdNameSso',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.grid.swdNameSso',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'swdCodeEloc',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.grid.swdCodeEloc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    swdIdSpwFilter : '',
    swdNameSpaFilter : '',
    swdIdSpaFilter : '',
    sprdSpaIdentCodeFilter : '',
    swdStatusFilter : '',
    swdCodeSatFilter : '',
    swdCodeSsoFilter : '',
    swdCodeElocFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'swdIdSpwFilter',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.filter.swdIdSpw',
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'swdNameSpaFilter',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.filter.swdNameSpa',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emSppSparePartsSpa'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"swdIdSpa":"id"}'
                }
        },
        {
        key: 'sprdSpaIdentCodeFilter',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.filter.sprdSpaIdentCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'swdCodeSatFilter',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.filter.swdCodeSat',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emSppAttribute'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'swdCodeSsoFilter',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.filter.swdCodeSso',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emSppSource'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'swdCodeElocFilter',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.filter.swdCodeEloc',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emSppLocation'
            ,correspondingField: 'code'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'swdIdSpw',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.entity.swdIdSpw',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'swdNameSpa',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.entity.swdNameSpa',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emSppSparePartsSpa'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"swdIdSpa":"id"}'
                }
        },
        {
        key: 'sprdSpaIdentCode',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.entity.sprdSpaIdentCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'swdPrice',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.entity.swdPrice',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'swdNum',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.entity.swdNum',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
            ,required: true
                }
        },
        {
        key: 'swdUnit',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.entity.swdUnit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'swdCodeSat',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.entity.swdCodeSat',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emSppAttribute'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'swdCodeSso',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.entity.swdCodeSso',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emSppSource'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'swdCodeEloc',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.entity.swdCodeEloc',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emSppLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'remark',
        label: 'label.em.spareparts.emSppWarehousingDetSwd.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmSppWarehousingDetSwd, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
